import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { CertificadosService } from 'src/app/services/certificados.service';

@Component({
    selector: "page-certificados",
    templateUrl: "certificados.component.html",
    styleUrls: ["certificados.component.css"],
    providers: [UserService, CertificadosService]
})

export class CertificadosComponent implements OnInit{

    public identity;
    public token;

    constructor(private _router: Router, private _userService: UserService, private _CertificadosService:CertificadosService){

    }

    ngOnInit(){
      console.log('inicio');
        if(!sessionStorage.getItem('identity-domCloud') || !sessionStorage.getItem('token-domCloud')){
            this._router.navigate(['/']);
          } else {
            this.identity = this._userService.getIdentity();
            this.token = this._userService.getToken();
          }
    }
    
}